import type { IdentityProvider } from '../core/contracts';

const KEY = 'npay-ar-demo.device-id';

/**
 * Demo identity: a UUID persisted per device.
 *
 * Persisted rather than per-page-load on purpose. A id that changes on every reload is not what a
 * platform means by identity, and it could not support the daily participation limit the
 * reference design implies — so the demo at least keeps the right shape.
 */
export class SessionUuidIdentity implements IdentityProvider {
  async getId(): Promise<string> {
    try {
      const existing = localStorage.getItem(KEY);
      if (existing) return existing;
      const id = crypto.randomUUID();
      localStorage.setItem(KEY, id);
      return id;
    } catch {
      // Private mode / blocked storage: fall back to an ephemeral id rather than failing the run.
      return crypto.randomUUID();
    }
  }
}
